"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Caret = void 0;
var _jsxRuntime = require("react/jsx-runtime");
var Caret = function Caret() {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.13518 9.12553C6.31542 8.95816 6.60765 8.95816 6.7879 9.12553L12 13.9653L17.2121 9.12553C17.3923 8.95816 17.6846 8.95816 17.8648 9.12553C18.0451 9.29289 18.0451 9.56425 17.8648 9.73162L12.3264 14.8745C12.1461 15.0418 11.8539 15.0418 11.6736 14.8745L6.13518 9.73162C5.95494 9.56425 5.95494 9.29289 6.13518 9.12553Z"
    })
  });
};
exports.Caret = Caret;